import { combineReducers } from "redux";
import masterDataNematodeNematodeSurveyTypeReducer from "./surveyType/reducer";

const masterDataNematodeReducer = combineReducers({
    surveyType: masterDataNematodeNematodeSurveyTypeReducer,
});

export default masterDataNematodeReducer;